import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IHotelInfoResult } from "types";

type InitialState = {
  prices: Partial<{ [hotelID: string]: IHotelInfoResult }>;
};

const initialState: InitialState = {
  prices: {},
};

export const slice = createSlice({
  name: "hotels",
  initialState: initialState,
  reducers: {
    setHotelPriceInfo: (state, action: PayloadAction<IHotelInfoResult>) => {
      const { hotel_identifier, ...props } = action.payload;
      state.prices = {
        ...state.prices,
        [hotel_identifier]: { ...props, hotel_identifier },
      };
    },
  },
});

export const {
  reducer,
  actions: { setHotelPriceInfo },
} = slice;
